<template>
  <div class="expert-select-container">
    <el-select
      v-model="selectedValue"
      :disabled="readonly"
      :placeholder="$t('Seçin')"
      filterable
      clearable
       size="small"
       class="indepentend-user-select"
    >
      <el-option
        v-for="item in data"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      />
    </el-select>
  </div>
</template>

<script>
import { usersbyrole } from "../../services/sales";

export default {
  props: {
    value: [Number, String],
    size: String,
    readonly: { type: Boolean, default: false },
  },
  data() {
    return {
      data: [],
      selectedValue: this.value,
    };
  },
  methods: {
    handleInput(value) {
      this.$emit("input", value);
    },

    getData() {
      usersbyrole(112).then((response) => {
        if (response.data) {
          this.data = response.data;
        } else {
          this.$message({
            type: "error",
            message: 'Independent expert users: No data found!',
          });
        }
      });
    }
  },
  mounted() {
    this.getData();
  },
  watch: {
    value(newVal) {
      this.selectedValue = newVal;
    },
    selectedValue(newVal) {
      this.handleInput(newVal);
    }
  },
};
</script>

<style scoped>
.indepentend-user-select {
  width: 100%;
}

</style>